import { format, isValid, parse } from 'date-fns';

export const stringToTime = (time: string | null) => {
  if (!time) return null;
  const [h, m] = time.split(':').map(Number);
  const d = new Date();
  d.setHours(h, m, 0, 0);
  return d;
};

export const dateToTimeString = (date: Date) => {
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
};

export const stringToYmdDate = (dateStr: string) => {
  const date = parse(dateStr, 'yyyy-MM-dd', new Date());
  return isValid(date) ? date : null;
};

export const dateToYmdString = (d: Date | null): string => {
  return d ? format(d, 'yyyy-MM-dd') : '';
};

export const stringToYmDate = (dateStr: string) => {
  const date = parse(dateStr, 'yyyy-MM', new Date());
  return isValid(date) ? date : null;
};
